import React, {useEffect, useState} from 'react';
import {withTranslation} from 'react-i18next';
import {FontAwesomeIcon} from '@fortawesome/react-fontawesome';
import {TreeView} from '@mui/x-tree-view/TreeView';
import {TreeItem} from '@mui/x-tree-view/TreeItem';
import Constants from "../../../config/constants";
import {styled} from "@mui/material/styles";

const TreeViewRegion = styled(TreeView)(({ theme }) => ({
    '& .MuiTreeItem-content' : {
        textAlign: 'center',
        padding: '0px',
    },
    '& .MuiTreeItem-iconContainer' : {
        width: '0px !important',
    },
    '& .MuiTreeItem-label' : {
        paddingLeft: '0px !important',
        marginLeft: '-4px !important',
    },
    '& .MuiTreeItem-group' : {
        marginLeft: '0px !important',
    },
    color: '#FFF',

}));

const RouteRegionComponent = ({screenName, nodes, updateRegionQuery, regionIds, openRegionId, children}) => {
    const localStoragePrefixKey = screenName + '-OME-';
    const localStorageRouteRegionComponentRegionId = localStorage.getItem(localStoragePrefixKey + 'routeRegionComponentRegionId') !== null ? parseInt(localStorage.getItem(localStoragePrefixKey + 'routeRegionComponentRegionId')) : null;
    const localStorageRouteRegionComponentNodeIds = localStorage.getItem(localStoragePrefixKey + 'routeRegionComponentNodeIds');
    // const [openRegionId, setOpenRegionId] = useState(localStorageRouteRegionComponentRegionId);
    const [expanded, setExpanded] = useState(localStorageRouteRegionComponentNodeIds !== null ? JSON.parse(localStorageRouteRegionComponentNodeIds) : []);
    const listRef = React.useRef();

    if (openRegionId && !expanded.includes('' + openRegionId)) {
        setExpanded([...expanded, ('' + openRegionId)]);
    }

    // if (openRegionId && (!query.hasOwnProperty('openRegionId') || query.openRegionId !== openRegionId)) {
    //     setQuery({...query, openRegionId: openRegionId, offset: 0});
    // }
    useEffect(() => {
        if (!openRegionId && expanded.length > 0) {
            updateRegionQuery(expanded[0]);
        }
    }, []);
    // useEffect(() => {
    //     if (openRegionId && openRegionId !== query?.openRegionId) {
    //         updateRegionQuery(openRegionId);
    //         setQuery({...query,
    //             openRegionId: openRegionId,
    //             offset:0});
    //     }
    // }, [query]);

    const openRegionClick = (node, open, updateLocalStorage = true) => {
        const regionId = node.id;
        localStorage.setItem(screenName + '-' + Constants.localStorageKey.searchListItemResult, 0);
        //Close if region is alreay open, ask for open and not singleRootNode
        if ((regionId === openRegionId || !open)) {
            const oldExpanded = [...expanded];
            const index = oldExpanded.indexOf(''+node.id);
            oldExpanded.splice(index, 1);
            setExpanded(oldExpanded);
            if (oldExpanded.length > 0) {
                updateRegionQuery(oldExpanded[0]);
            } else {
                updateRegionQuery(null);
            }

            if (updateLocalStorage) {
                localStorage.setItem(localStoragePrefixKey + 'routeRegionComponentRegionId', null);
                localStorage.setItem(localStoragePrefixKey + 'routeRegionComponentNodeIds', JSON.stringify([]));
            }
            //setOpenRegionId(null);
        } else {
            if (updateLocalStorage) {
                localStorage.setItem(localStoragePrefixKey + 'routeRegionComponentRegionId', regionId);
                localStorage.setItem(localStoragePrefixKey + 'routeRegionComponentNodeIds', JSON.stringify(node.ids));
            }
            //setOpenRegionId(regionId);
            setExpanded(node.ids);
            updateRegionQuery(regionId);
            //setQuery({...query, offset: 0});
        }
    };

    function TreeNode({ node, children }) {
        const regionLabel = node.label;
        const nodeLvl = node?.lvl ? node.lvl : 0;
        const showList = openRegionId === node.id;

        if (!regionIds.hasOwnProperty(node.id)) {
            return null;
        }

        const isSingleRootNode = nodes.length === 1 && nodeLvl === 1;
        const isOpen = expanded.includes(""+ node.id);

        return (<TreeItem
            key={node.id}
            nodeId={"" + node.id}
            label={
                <div className={"listRegionHeader"}
                     // ref={regionRef}
                >
                    <a href="#" role="button"
                       data-id={node.id}
                       style={{backgroundColor: node.color, padding: '0 ' + (10 + (nodeLvl-1)*20) + 'px'}}
                       onClick={() => {
                           openRegionClick(node, !isOpen);
                       }}
                    >
                        {isOpen && <FontAwesomeIcon icon={["fas", "chevron-up"]} />}
                        {!isOpen && <FontAwesomeIcon icon={["fas", "chevron-down"]} />}
                        &nbsp;
                        {regionLabel}
                    </a>
                </div>
            }
        >
            {showList && <>{children}</>}
            {Array.isArray(node.children) && node.children.length > 0 && <TreeNodes nodes={node.children}>{children}</TreeNodes>}
        </TreeItem>);
    }

    function TreeNodes({nodes, children}) {
        return (
            <>
                {nodes.map(node => (
                    <TreeNode node={node} key={node.id}>
                        {children}
                    </TreeNode>
                ))}
            </>
        );
    }

    return (<div className={"flexGrowAuto"} ref={listRef}>
        <div style={{height:'100%'}}>
            <TreeViewRegion
                defaultCollapseIcon={<></>}
                defaultExpandIcon={<></>}
                expanded={expanded}
            >
                <TreeNodes nodes={nodes}>
                    {children}
                </TreeNodes>
            </TreeViewRegion>
        </div>
    </div>);
};

export default withTranslation()(RouteRegionComponent);